import React from "react";
import CustomElement from "./custom-element";

export default function Division(props) {
    return (
        <CustomElement  { ...{Tag:"div", ...props} }>{props.children}</CustomElement>
    )
}